export enum WorkType {
    SHOW_CONTACTS_FOR_ALL = 1,
    SHOW_CONTACTS_AFTER_SELECT = 2,
}
